/*
  Favoritos (wishlist) — Finger3flip
  Guarda los productos en el navegador del cliente (localStorage).
*/
(function () {
  'use strict';

  if (window.WishlistF3) return;

  var KEY = 'f3_wishlist';
  var HEART = 'M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 1 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z';

  var I18N = {
    es: { add: 'Añadir a favoritos', remove: 'Quitar de favoritos', sold_out: 'Agotado' },
    en: { add: 'Add to wishlist', remove: 'Remove from wishlist', sold_out: 'Sold out' }
  };

  function cfg() { return window.wishlistConfig || {}; }

  function lang() {
    var l = cfg().locale || document.documentElement.lang || 'es';
    return String(l).slice(0, 2).toLowerCase();
  }

  function str(key, fallback) {
    var dict = I18N[lang()];
    if (dict && dict[key]) return dict[key];
    var s = cfg().strings || {};
    return s[key] || fallback;
  }

  function rootUrl() {
    var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || cfg().rootUrl || '/';
    return String(r).replace(/\/$/, '');
  }

  function read() {
    try {
      var raw = JSON.parse(window.localStorage.getItem(KEY));
      if (!Array.isArray(raw)) return [];
      return raw.filter(function (h) { return typeof h === 'string' && h.length > 0; });
    } catch (e) { return []; }
  }

  function write(list) {
    try { window.localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { list: list } }));
  }

  var Wishlist = {
    all: read,
    count: function () { return read().length; },
    has: function (h) { return read().indexOf(h) !== -1; },
    add: function (h) { var l = read(); if (l.indexOf(h) === -1) { l.unshift(h); write(l); } },
    remove: function (h) { write(read().filter(function (x) { return x !== h; })); },
    toggle: function (h) {
      if (Wishlist.has(h)) { Wishlist.remove(h); return false; }
      Wishlist.add(h);
      return true;
    }
  };
  window.WishlistF3 = Wishlist;

  window.addEventListener('storage', function (e) {
    if (e.key === KEY) {
      document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { list: read() } }));
    }
  });

  function esc(v) {
    return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function money(cents) {
    try {
      return new Intl.NumberFormat(cfg().locale || document.documentElement.lang || 'es-ES', {
        style: 'currency', currency: cfg().currency || 'EUR'
      }).format(cents / 100);
    } catch (e) { return (cents / 100).toFixed(2); }
  }

  function sized(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function heartSvg() {
    return '<svg class="wishlist-heart" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="' + HEART + '"/></svg>';
  }

  function makeButton(handle, variant, withText) {
    var el = document.createElement('wishlist-button');
    el.className = 'wishlist-button wishlist-button--' + variant;
    el.setAttribute('data-handle', handle);
    el.setAttribute('data-label-add', str('add', 'Añadir a favoritos'));
    el.setAttribute('data-label-remove', str('remove', 'Quitar de favoritos'));
    el.innerHTML = '<button type="button" class="wishlist-button__btn">' + heartSvg() +
      (withText ? '<span class="wishlist-button__text"></span>' : '') + '</button>';
    return el;
  }

  /* ---------- Icono de la cabecera: solo visible si hay favoritos ---------- */
  function syncHeaderIcon() {
    var link = document.getElementById('wishlist-icon-bubble');
    if (!link) return;
    if (Wishlist.count() > 0) {
      link.classList.add('is-visible');
    } else {
      link.classList.remove('is-visible');
    }
  }

  /* ---------- <wishlist-button> ---------- */
  if (!window.customElements.get('wishlist-button')) {
    window.customElements.define('wishlist-button', class extends HTMLElement {
      connectedCallback() {
        this.handle = this.getAttribute('data-handle');
        this.button = this.querySelector('button');
        if (!this.handle || !this.button) return;
        this._onClick = function (e) {
          e.preventDefault();
          e.stopPropagation();
          Wishlist.toggle(this.handle);
        }.bind(this);
        this._sync = this.sync.bind(this);
        this.button.addEventListener('click', this._onClick);
        document.addEventListener('wishlist:change', this._sync);
        this.sync();
      }
      disconnectedCallback() {
        if (this._sync) document.removeEventListener('wishlist:change', this._sync);
      }
      sync() {
        var active = Wishlist.has(this.handle);
        this.classList.toggle('is-active', active);
        this.button.setAttribute('aria-pressed', active ? 'true' : 'false');
        var label = active ? str('remove', 'Quitar de favoritos') : str('add', 'Añadir a favoritos');
        this.button.setAttribute('aria-label', label);
        this.button.setAttribute('title', label);
        var text = this.querySelector('.wishlist-button__text');
        if (text) text.textContent = label;
      }
    });
  }

  /* ---------- <wishlist-count> ---------- */
  if (!window.customElements.get('wishlist-count')) {
    window.customElements.define('wishlist-count', class extends HTMLElement {
      connectedCallback() {
        this._sync = this.sync.bind(this);
        document.addEventListener('wishlist:change', this._sync);
        this.sync();
      }
      disconnectedCallback() {
        if (this._sync) document.removeEventListener('wishlist:change', this._sync);
      }
      sync() {
        var n = Wishlist.count();
        var slot = this.querySelector('[data-count]');
        if (slot) slot.textContent = n;
        if (n > 0) { this.removeAttribute('hidden'); } else { this.setAttribute('hidden', ''); }
        syncHeaderIcon();
      }
    });
  }

  /* ---------- <wishlist-list> (página de favoritos) ---------- */
  function cardHtml(p) {
    var img = p.featured_image ? sized(p.featured_image, 600) : '';
    var price = money(p.price);
    if (p.compare_at_price && p.compare_at_price > p.price) {
      price = '<s class="wishlist-card__was">' + money(p.compare_at_price) + '</s> <span class="wishlist-card__now">' + price + '</span>';
    }
    var removeLabel = str('remove', 'Quitar de favoritos');
    return '<li class="wishlist-card">' +
      '<a class="wishlist-card__link" href="' + esc(p.url) + '">' +
        '<div class="wishlist-card__media">' +
          (img ? '<img src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') +
          (p.available ? '' : '<span class="wishlist-card__badge">' + esc(str('sold_out', 'Agotado')) + '</span>') +
        '</div>' +
        '<div class="wishlist-card__info">' +
          '<span class="wishlist-card__title">' + esc(p.title) + '</span>' +
          '<span class="wishlist-card__price">' + price + '</span>' +
        '</div>' +
      '</a>' +
      '<button type="button" class="wishlist-card__remove" data-remove="' + esc(p.handle) + '" aria-label="' + esc(removeLabel) + '" title="' + esc(removeLabel) + '">' + heartSvg() + '</button>' +
    '</li>';
  }

  if (!window.customElements.get('wishlist-list')) {
    window.customElements.define('wishlist-list', class extends HTMLElement {
      connectedCallback() {
        this.grid = this.querySelector('[data-wishlist-grid]');
        this.empty = this.querySelector('[data-wishlist-empty]');
        this._render = this.render.bind(this);
        document.addEventListener('wishlist:change', this._render);
        if (this.grid) {
          this.grid.addEventListener('click', function (e) {
            var btn = e.target.closest('[data-remove]');
            if (!btn) return;
            e.preventDefault();
            Wishlist.remove(btn.getAttribute('data-remove'));
          });
        }
        this.render();
      }
      disconnectedCallback() {
        if (this._render) document.removeEventListener('wishlist:change', this._render);
      }
      render() {
        var self = this;
        var handles = Wishlist.all();
        if (!this.grid) return;
        if (!handles.length) {
          this.grid.innerHTML = '';
          if (this.empty) this.empty.removeAttribute('hidden');
          return;
        }
        if (this.empty) this.empty.setAttribute('hidden', '');
        this.grid.setAttribute('aria-busy', 'true');
        var base = rootUrl();
        Promise.all(handles.map(function (h) {
          return fetch(base + '/products/' + encodeURIComponent(h) + '.js')
            .then(function (r) { return r.ok ? r.json() : null; })
            .catch(function () { return null; });
        })).then(function (results) {
          var html = '';
          var missing = [];
          results.forEach(function (p, i) {
            if (!p) { missing.push(handles[i]); return; }
            html += cardHtml(p);
          });
          self.grid.innerHTML = html;
          self.grid.removeAttribute('aria-busy');
          if (missing.length) {
            write(handles.filter(function (h) { return missing.indexOf(h) === -1; }));
          }
        });
      }
    });
  }

  /* ---------- Corazón automático en fichas y página de producto ---------- */
  function handleFromHref(href) {
    if (!href) return null;
    var m = href.split('?')[0].match(/\/products\/([^\/#]+)/);
    return m ? m[1] : null;
  }

  function decorateCards(scope) {
    if (cfg().cardButtons === false) return;
    var root = scope && scope.querySelectorAll ? scope : document;
    var cards = root.querySelectorAll('.card-wrapper:not([data-wishlist-ready])');
    Array.prototype.forEach.call(cards, function (card) {
      card.setAttribute('data-wishlist-ready', 'true');
      var link = card.querySelector('a[href*="/products/"]');
      var handle = link ? handleFromHref(link.getAttribute('href')) : null;
      if (!handle) return;
      card.appendChild(makeButton(handle, 'card', false));
    });
  }

  function attachHeart(box, handle) {
    if (!box || box.hasAttribute('data-wishlist-ready')) return;
    box.setAttribute('data-wishlist-ready', 'true');
    if (window.getComputedStyle(box).position === 'static') {
      box.style.position = 'relative';
    }
    box.appendChild(makeButton(handle, 'media', false));
  }

  // Caja visual de la imagen dentro de cada diapositiva del carrusel.
  // Dawn ha usado varios nombres de clase según la versión.
  var MEDIA_BOX = '.product-media-container, .product__media-container, .product__media';

  function decorateProductPage() {
    if (cfg().productButton === false) return;
    var handle = handleFromHref(window.location.pathname);
    if (!handle) return;

    var gallery = document.querySelector('media-gallery');
    if (gallery) {
      var items = gallery.querySelectorAll('.product__media-item');
      if (items.length) {
        Array.prototype.forEach.call(items, function (item) {
          attachHeart(item.querySelector(MEDIA_BOX) || item, handle);
        });
        return;
      }
      attachHeart(gallery.querySelector(MEDIA_BOX) || gallery.querySelector('slider-component'), handle);
      return;
    }

    attachHeart(document.querySelector(MEDIA_BOX) || document.querySelector('.product__media-wrapper'), handle);
  }

  function decorate() {
    decorateCards(document);
    decorateProductPage();
  }

  function init() {
    syncHeaderIcon();
    decorate();
    if (window.MutationObserver) {
      var pending = false;
      var obs = new MutationObserver(function () {
        if (pending) return;
        pending = true;
        window.requestAnimationFrame(function () { pending = false; decorate(); });
      });
      obs.observe(document.body, { childList: true, subtree: true });
    }
  }

  document.addEventListener('wishlist:change', syncHeaderIcon);
  syncHeaderIcon();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
